import { validateIPaddress } from "@lib/helpers/StringHelper";
import { AuthRoles } from "@lib/types";
import * as yup from "yup";

export const managerSchema = yup.object().shape({
  firstName: yup.string().required().min(2).max(20),
  lastName: yup.string().required().min(1).max(20),
  email: yup.string().required().email(),
  password: yup.string().required().min(4),
  phone: yup.string().nullable().min(10).max(15),
  phoneCode: yup.string().nullable().min(1).max(10),
  isTwoFactorAuthEnabled: yup.bool().required(),
  ipWhitelist: yup
    .array()
    .of(yup.string())
    .nullable()
    .test({
      test: (value) => {
        if (value) {
          return value.every((ip) => validateIPaddress(ip));
        }
        return true;
      },
    }),
  role: yup.string().required().oneOf(Object.values(AuthRoles)),
  providerId: yup.string().uuid(),
  customerId: yup.string().uuid(),
  isManagement: yup.bool(),
});
